import { add } from '@edicom/common/math/add';
import { sub } from '@edicom/common/math/sub';
import { mul } from '@edicom/common/math/mul';
import { div } from '@edicom/common/math/div';
import { mod } from '@edicom/common/math/mod';
import { divide } from '@edicom/common/math/divide';
import { countDecimals } from '@edicom/common/math/countDecimals';

export default {
  add,
  sub,
  mul,
  div,
  mod,
  divide,
  countDecimals,
};
